import { IconTokens, StepperStateToken, StepperTypeTokens, } from '@voltmoney/schema';
export const args = {
    type: StepperTypeTokens.VERTICAL,
    data: [
        {
            id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
            step: '1',
            title: 'Basic Details',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'KYC',
            status: StepperStateToken.COMPLETED,
            message: '',
            icon: IconTokens.GreenRupee,
        },
        {
            id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
            step: '2',
            title: 'Bank Details',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'Bank account',
            status: StepperStateToken.COMPLETED,
            message: '',
            icon: IconTokens.GreenClipboard,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            step: '3',
            title: 'Fetch portfolio',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'AutoPay',
            status: StepperStateToken.COMPLETED,
            statusText: StepperStateToken.COMPLETED,
            message: '',
            icon: IconTokens.GreenRupee,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d74',
            step: '4',
            title: 'Select portFolio',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'Agreement',
            status: StepperStateToken.COMPLETED,
            statusText: StepperStateToken.COMPLETED,
            message: 'Steps pending in investor',
            icon: IconTokens.GreenRupee,
        },
        {
            id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
            step: '5',
            title: 'KYC verification',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'KYC verification',
            status: StepperStateToken.FAILED,
            message: '',
            icon: IconTokens.GreenRupee,
        },
        {
            id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
            step: '6',
            title: 'Pledge portfolio',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'Bank account',
            status: StepperStateToken.NOT_STARTED,
            message: '',
            icon: IconTokens.GreenRupee,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            step: '7',
            title: 'Share unique referral link within clients, MFDs & IFAs',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'AutoPay',
            status: StepperStateToken.IN_PROGRESS,
            message: '',
            icon: IconTokens.GreenRupee,
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d74',
            step: '8',
            title: 'Sign Agreement',
            subTitle: 'lorme ipsum doler smit en',
            horizontalTitle: 'Agreement',
            status: StepperStateToken.NOT_STARTED,
            message: '',
            icon: IconTokens.GreenRupee,
        },
    ],
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(StepperTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    // state: {
    // 	control: 'select',
    // 	options: [
    // 		...Object.values(StepperStateToken).filter(
    // 			(k) => typeof k === 'string',
    // 		),
    // 	],
    // },
    onPress: { action: 'clicked' },
};
